import { CSSProperties } from 'react';

import { ITailwindCssPluginConfig } from '../../shared/types/ITailwindCssPlugin';

const COLUMN_WIDTH: number = 70;
const GUTTER_WIDTH: number = 16;
const LARGE_GUTTER_WIDTH: number = 24;

export function gridPlugin (config: ITailwindCssPluginConfig): void {
    const { addUtilities }: ITailwindCssPluginConfig = config;
    const gridWidths: Record<string, CSSProperties> = {};

    for (let cols: number = 1; cols <= 12; cols = cols + 1) {
        const columnsWidth: number = cols * COLUMN_WIDTH;
        const gutters: number = cols - 1;

        gridWidths[`.w-${cols}-col`] = {
            width: `${columnsWidth + (gutters * GUTTER_WIDTH)}px`,
        };
        gridWidths[`.w-lg-${cols}-col`] = {
            width: `${columnsWidth + (gutters * LARGE_GUTTER_WIDTH)}px`,
        };
    }

    addUtilities(gridWidths, {
        variants: ['responsive'],
    });
}
